export const capitalise = (input) => {
    if (!input || 'string' !== typeof input) { return input; }
    if (input.length === 1) { return input.toUpperCase(); }
    return `${input.charAt(0).toUpperCase()}${input.substr(1)}`;
};

export const defaultAddressFields = ['address1', 'address2', 'address3', 'city', 'postalCode'];
export const compactAddressFields = ['address1', 'city', 'postalCode'];

export const formatAddress = (data, options = {}) => {
    const {
        separator = ', ',
        fields = defaultAddressFields,
        prefix = '',
        suffix = '',
        defaultValue = null
    } = options;

    const address = [];
    fields.forEach(field => {
        if (!!data[field]) {
            const e = data[field].trim();
            if (e) {
                address.push(e);
            }
        }
    });
    if (address.length === 0) { return defaultValue; }
    return `${prefix}${address.join(separator).trim()}${suffix}`;
};


export const fullNameFields = ['title', 'firstName', 'initials', 'lastName'];
export const shortNameFields = ['firstName', 'lastName'];
export const sortingNameFields = ['lastName', 'firstName', 'initials'];

export const formatName = (data, options = {}) => {
    const {
        fields = fullNameFields,
        separator = ' ',
        prefix = '',
        suffix = '',
        defaultValue = null
    } = options;
    const name = [];
    fields.forEach(field => {
        if (!!data[field]) {
            const e = data[field].trim();
            if (e) {
                name.push(e);
            }
        }
    });
    if (name.length === 0) { return defaultValue; }
    return `${prefix}${name.join(separator).trim()}${suffix}`;
};

export const toNumber = (value, defaultValue = null) => {
    const num = Number(value);
    return isNaN(num) ? defaultValue : num;
};

export const isSurroundedBy = (value, character) => {
    if (!character) { return true; }
    if (!value || value.length < 2) { return false; }
    return value.charAt(0) === character && value.charAt(value.length - 1) === character;
};
